import { fetchAuthSession } from 'aws-amplify/auth';

const getIdToken = async () => {
  try {
    const session = await fetchAuthSession();
    const idToken = session.tokens?.idToken;
    return idToken;
  } catch (e) {
    console.log('error getting id token:', e);
    throw e;
  }
};

export { getIdToken };
